import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { patientQKeys } from "@hooks/queries/patient/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  recordId: string;
  patientId: string;
}

export const useDeleteMedicalRecord = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ recordId }: MutationProps) => {
      return api.delete(`patient/conditions/${recordId}`);
    },

    onSuccess: (_, variables) => {
      showSuccessNotification({
        title: "success",
        message: "delete-medical-record-success",
      });
      queryClient.invalidateQueries({
        queryKey: patientQKeys.medicalHistory(variables.patientId),
      });
    },

    onError: res => {
      console.error("[From Delete Medical Record]", res);

      handleErrors(res, "mutation");
    },
  });
};
